import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: theme.spacing(2, 0),
    borderBottom: '1px solid rgba(33, 33, 33, 0.08)'
  }
}))
